import RouteTemplate from 'ember-route-template';

import { get } from '@ember/helper';
import Component from '@glimmer/component';

import ErrorContact from 'rise-ui/components/error-contact.gjs';
import ErrorPage from 'rise-ui/components/error-page.gjs';
import PageNotFound from 'rise-ui/components/page-not-found.gjs';
import contains from 'rise-ui/helpers/contains.js';

export default RouteTemplate(class ErrorTemplate extends Component {
  <template>
    {{#if (contains (get @model.errors "0.detail") "The adapter could not find the resource")}}
      <PageNotFound/>
    {{else}}
      <ErrorPage as | error |>
        <error.title>Unknown Error</error.title>
        <error.subtitle>An unexpected error has occurred.</error.subtitle>
        <error.content><ErrorContact/></error.content>
      </ErrorPage>
    {{/if}}
    {{outlet}}
  </template>
});
